import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";


export class OrganizationOverviewCtrl implements IController {

  sites: any;
  from: any;
  to: any;

  public filterConfig: any;
  public isListView: boolean = false;

  constructor(private $state, private dateRangeTimeFiltersService: DateRangeTimeFiltersService) {
  }

  $onInit() {
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      queryString: undefined
    }
  }

  onRangeChanged(range) {
    this.changeRange(range)
  }

  private changeRange(range) {
    if (!_.isUndefined(range) &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) || !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {
      this.filterConfig.range = range;
      this.$state.go('.', {from: range.dateStart, to: range.dateEnd}, {notify: false, reload: false})
    }
  }


}

angular
  .module('bringoz.admin.organizations')
  .component('organizationOverview', {
    bindings: {
      sites: '<',
      from: '<',
      to: '<'
    },
    template: require('./organization-overview.html').default,
    controller: OrganizationOverviewCtrl
  });
